export default "https://cdn-static.gokick.com/assets/6706629b3df14a4b3713b9aca1ff59a1c44b8347/images/citrus-zen.2d0942f5031f42be498b3d61071e3237.png";